<template>
  <div ref="whole_page" class="dark-layout">
    <vx-card title="">
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <vx-card class="glow-effect_dark card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text school-primary_gradient">
                  <span
                    ><feather-icon
                      class="pt-1"
                      icon="FilterIcon"
                      svg-classes="stroke-current"
                    ></feather-icon
                  ></span>
                </div>
              </template>

              <v-select
                id="filter-select"
                ref="moduleDropdown"
                class="w-full style-chooser-light"
                placeholder="Filter module(s)..."
                multiple
                :closeOnSelect="false"
                :options="modulesList"
                v-model="filterModules"
              />
            </vx-input-group>
          </vx-card>
        </div>
        <div class="vx-col w-1/4 self-center">
          <div class="grid">
            <vs-checkbox
              class="float-left"
              style="width: fit-content"
              name="cb"
              v-model="showMessages"
              v-if="false"
              >Show Messages</vs-checkbox
            >
            <vs-checkbox
              class="mt-1 float-left"
              style="width: fit-content"
              name="cb"
              v-model="showCallbacks"
              >Show Callbacks</vs-checkbox
            >
            <vs-checkbox
              v-show="!showMessages"
              class="mt-1 float-left"
              style="width: fit-content"
              v-model="showAssigned"
              >Show Assigned To Me</vs-checkbox
            >
          </div>
        </div>
        <div class="vx-col w-1/4 self-center">
          <div class="flex">
            <vs-checkbox v-model="autoRefresh"
              >Auto Refresh&nbsp;<small>(every 5 mins)</small></vs-checkbox
            >
            <vs-button
              v-if="!autoRefresh"
              icon-pack="feather"
              radius
              icon="icon-refresh-cw"
              class="ml-4"
              @click="refresh"
            />
          </div>
        </div>
      </div>
    </vx-card>
    <vs-divider><h4>Callbacks</h4></vs-divider>
    <span v-show="unassignedSessions.length == 0" class="white-text">No data Available</span>
    <div class="swiper-container">
      <div class="swiper-inner">
        <swiper :options="swiperOption" >
          <swiper-slide
            v-for="(session, index) in unassignedSessions.filter(item => !(item.mentorSessionTypeId == 1 && item.mentorSessionStatusId ==3) && item.mentorSessionStatusId != 6)"
            :key="index"
          >
            <vx-card ref="assign_card" class="vs-con-loading__container">
              <div v-if="session.mentorSessionTypeId == 1" class="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style="color: white"
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-file-text"
                >
                  <path
                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  ></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                <h3 class="ml-3">Message</h3>
              </div>
              <div v-else-if="session.mentorSessionTypeId == 2" class="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style="color: white"
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-phone-outgoing"
                >
                  <polyline points="23 7 23 1 17 1"></polyline>
                  <line x1="16" y1="8" x2="23" y2="1"></line>
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  ></path>
                </svg>
                <h3 class="ml-3">Callback</h3>
              </div>
              <vs-divider />
              <div class="vx-row">
                <div class="vx-col w-full">
                  <h5>
                    {{
                      currentDay == formatDisplayDate(session.createdDate)
                        ? `Today ${formatDisplayTime(session.createdDate)}`
                        : `${formatDisplayDate(
                            session.createdDate
                          )} ${formatDisplayTime(session.createdDate)}`
                    }}
                  </h5>
                </div>
              </div>
              <vs-divider />
              <div class="vx-row mb-2">
                <div class="vx-col w-1/3">
                  <h6 class="float-left">From:</h6>
                </div>
                <div class="vx-col w-2/3">
                  <h6 class="float-left">
                    <strong>{{ session.studentFullName }}</strong>
                  </h6>
                </div>
              </div>
              <VuePerfectScrollbar
                class="chat-scroll-area"
                :settings="settings"
              >
                <div
                  v-if="session.mentorSessionTypeId == 1"
                  class="vx-row mt-2"
                  style="height: 150px"
                >
                  <div class="vx-col w-1/5">
                    <h6 class="float-left fixed">Message:</h6>
                  </div>
                  <div class="vx-col w-4/5">
                    <h6 class="float-left text-left" style="line-spacing: 1.3">
                      <strong>{{ session.message }}</strong>
                    </h6>
                  </div>
                </div>
                <div
                  v-if="session.mentorSessionTypeId == 2"
                  class="vx-row mt-2"
                  style="height: 150px"
                >
                  <div class="vx-col w-1/3">
                    <h6 class="float-left fixed">Cell Number:</h6>
                  </div>
                  <div class="vx-col w-2/3">
                    <h6 class="float-left text-left" style="line-spacing: 1.3">
                      <strong>{{ session.phoneNumber }}</strong>
                    </h6>
                  </div>
                </div>
              </VuePerfectScrollbar>
              <div class="vx-row mt-4">
                <div class="vx-col w-full" v-if="session.mentorSessionStatusId != 3">
                  <vs-button
                    ref="button_submit"
                    id="submit-button"
                    icon-pack="feather"
                    icon="icon-check"
                    class="vs-con-loading__container w-full"
                    @click="assignToMe(session, index)"
                    >Assign to Me</vs-button
                  >
                </div>
                <div class="vx-col w-full" v-else>
                  <vs-button
                    ref="button_submit"
                    id="submit-button"
                    icon-pack="feather"
                    icon="icon-x"
                    class="vs-con-loading__container w-full"
                    @click="closeSession(session)"
                    >Close Session</vs-button
                  >
                </div>
              </div>
            </vx-card>
          <vs-popup title="Are you sure you want to close the session?" id="close-session-popup" :active.sync="closeSessionPopupActive">
            <div class="vx-row">
              <div class="vx-col w-full">
                <label for="comment_text">Comments:</label>
                <vs-textarea id="comment_text" class="mt-1" v-model="unassignedSessions.comment" />
              </div>
            </div>
            <div class="vx-row mt-3">
              <div class="vx-col w-full">
                <div class="mt-3">
                  <vs-button color="success" class="float-right" @click="closeMentorSession(unassignedSessions.comment)">Close</vs-button>
                </div>
              </div>
            </div>
          </vs-popup>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>

    <vs-divider><h4>Student Logbooks</h4></vs-divider>
    <div>
      <student-logbooks
        :isViewActive="isStudentLogbooksViewActive"
        :logbooks="logbooks"
        :showLoading="showLoading"
        @reloadLogbooks="getLogbooks"
        @getLogbooks="getLogbooks"
      />
    </div>

    <vs-divider/>

    <app-collapse
      accordion
      type="border"
      class="text-left"
    >

      <app-collapse-item title="Q&A's">
        <frequently-asked-questions
          :isViewActive="isFaqViewActive"
          :faqs="faqs"
          :modulesList="modulesList"
          @getFaqs="getFaqs"
        />
      </app-collapse-item>

      <app-collapse-item title="Multimedia Content">
        <multi-media-content
          :isViewActive="isMediaContentViewActive"
          :modulesList="modulesList"
        />
      </app-collapse-item>
    </app-collapse>
  </div>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import FrequentlyAskedQuestions from "./FrequentlyAskedQuestions.vue";
import MultiMediaContent from "./MultiMediaContent.vue";
import AppCollapse from '@/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@/components/app-collapse/AppCollapseItem.vue';
import StudentLogbooks from "./StudentLogbooks.vue";
export default {
  name: "MentorDashboard",
  data() {
    return {
      isFaqViewActive: false,
      isMediaContentViewActive: false,
      autoRefresh: false,
      showMessages: false,
      showCallbacks: true,
      showAssigned: false,
      filterModules: [],
      modulesList: [],
      refreshInterval: null,
      unassignedSessions: [],
      assignedSessions: [],
      origUnassignedSessions: [],
      currentFilterList: [],
      timeToDisplay: null,
      moduleDropdown: 0,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        autoplay: {
          enabled: false,
          delay: 5000,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1550: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1210: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          860: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        },
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7,
        suppressScrollX: true,
      },
      origFaqs: [],
      faqs: [],
      closeSessionPopupActive: false,
      selectedSession: [],
      isStudentLogbooksViewActive: true,
      logbooks: [],
      showLoading: false
    };
  },
  components: {
    vSelect,
    moment,
    swiper,
    swiperSlide,
    VuePerfectScrollbar,
    FrequentlyAskedQuestions,
    MultiMediaContent,
    AppCollapse,
    AppCollapseItem,
    StudentLogbooks
  },
  watch: {
    filterModules: function (currentList) {
      this.currentFilterList = currentList;
      this.filterByType();
    },
    autoRefresh: function (val) {
      var self = this;
      if (self.refreshInterval) {
        clearInterval(self.refreshInterval);
      }

      if (val) {
        self.refresh();
        self.refreshInterval = setInterval(function () {
          self.refresh();
        }, 600000);
      }
    },
    showMessages: function () {
      this.checkboxFilter();
    },
    showCallbacks: function () {
      this.checkboxFilter();
    },
    showAssigned: function () {
      this.checkboxFilter();
    },
  },
  computed: {
    currentDay: function () {
      return moment(new Date()).format("dddd, Do MMMM YYYY");
    },
  },
  methods: {
    formatDisplayDate(date) {
      return moment(new Date(date).toISOString()).format("dddd, Do MMMM YYYY");
    },
    formatDisplayTime(date) {
      return moment(new Date(date).toISOString()).format("HH:mm");
    },
    getMentorModules() {
      var self = this;
      
      var onSuccess = (response) => {
        if (response.data) {
          self.modulesList = response.data.map((item) => {
            return { label: item.text, value: item.value };
          });
          self.isFaqViewActive = true;
          self.isMediaContentViewActive = true;
          self.getFaqs();
        }
      };

      self.$ajaxGet(self, "MentorModule/GetModulesByMentor", onSuccess);
    },
    getUnassignedSessions(filterLists) {
      var self = this;
      var filterList = [];

      self.showLoadingOnElement("whole_page", 1, "material");

      var onSuccess = (response) => {
        self.origUnassignedSessions = response.data;
        self.unassignedSessions = response.data;
        self.assignedSessions = response.data;
      };
      var onFinally = (response) => {
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };
      if(filterLists != null  && filterLists.length > 0){
        filterLists.forEach(_question => {
        filterList.push({
          text: _question.label,
          value: _question.value
        });
      });
      }
      self.$ajaxPost(self,"MentorModule/GetUnassignedSessions", {Values: (filterList != null && filterList.length > 0) ? filterList : []}, onSuccess, onFinally);
    },
    refresh() {
      this.filterByType();
    },
    filterByType() {
      var self = this;
      if (self.currentFilterList.length > 0) {
        self.faqs = self.origFaqs.filter(
          (x) => self.currentFilterList.filter(
            (y) => y.value == x.moduleId).length > 0);

        self.getUnassignedSessions(self.currentFilterList);
      } 
      else {
        self.faqs = self.origFaqs;
      }

      if (self.showMessages && !self.showCallbacks && !self.showAssigned) 
      { self.unassignedSessions = self.unassignedSessions.filter(function (session) {
          return session.mentorSessionTypeId == 1;
        });
      } 
      else if (self.showCallbacks && !self.showMessages && !self.showAssigned) 
      { self.unassignedSessions = self.unassignedSessions.filter(function (session) {
          return session.mentorSessionTypeId == 2;
        });
      } 
      else if (self.showAssigned) 
      { self.unassignedSessions = self.unassignedSessions.filter(function (session) {
          return (session.mentorSessionStatusId == 3 && session.mentorSessionTypeId == 2);
        });
          var checks = document.getElementsByName("cb");
          for (var i = 0; i < checks.length; i++) {
            if(checks[i].checked){
              self.showCallbacks = false;
              self.showMessages = false;
              checks[i].checked = false;
            }
          }
      } else {
        self.unassignedSessions = self.origUnassignedSessions;
      }

      if (self.currentFilterList.length > 0) {
        var tempSessions = [];
        self.currentFilterList.forEach(function (item) {
          tempSessions = tempSessions.concat(
            self.unassignedSessions.filter(function (session) {
              return item.value == session.moduleId;
            })
          );
        });

        self.unassignedSessions = tempSessions;
      }
    },

    checkboxFilter(){
      var self = this;
      if (self.showMessages && !self.showCallbacks && !self.showAssigned) 
      { self.unassignedSessions = self.unassignedSessions.filter(function (session) {
          return session.mentorSessionTypeId == 1;
        });
      } 
      else if (self.showCallbacks && !self.showMessages && !self.showAssigned) 
      { self.unassignedSessions = self.unassignedSessions.filter(function (session) {
          return session.mentorSessionTypeId == 2;
        });
      } 
      else if (self.showAssigned) 
      { self.unassignedSessions = self.unassignedSessions.filter(function (session) {
          return (session.mentorSessionStatusId == 3 && session.mentorSessionTypeId == 2);
        });
          var checks = document.getElementsByName("cb");
          for (var i = 0; i < checks.length; i++) {
            if(checks[i].checked){
              self.showCallbacks = false;
              self.showMessages = false;
              checks[i].checked = false;
            }
          }
      } else {
        self.unassignedSessions = self.origUnassignedSessions;
      }
    },

    assignToMe(session, index) {
      var self = this;
      self.showLoadingOnSubmitButtons(
        self.$refs["assign_card"][index],
        1,
        "corners"
      );

      var onSuccess = (response) => {
        if(session.mentorSessionTypeId == 1){
          self.$router.push({ name: "Chat", query: { mentoring: true } });
        } else{
          self.refresh();
        }
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs["assign_card"][index].$el);
      };

      self.$ajaxGet(
        self,
        "MentorModule/AssignToMentor?sessionId=" + session.mentorSessionId,
        onSuccess,
        onFinally
      );
    },
    closeSession(session) {
      this.selectedSession = session;
      this.closeSessionPopupActive = true;
    },
    closeMentorSession(comment){
      var self = this;
      self.selectedSession.comment = comment;

      var onSuccess = response => {
        this.closeSessionPopupActive = false;
        self.getUnassignedSessions();
      };
      self.$ajaxGet(self, "MentorModule/ConcludeMentorSession?mentorSessionId=" + self.selectedSession.mentorSessionId + "&comment=" + self.selectedSession.comment, onSuccess);
    },
    getFaqs() {
      var self = this;
      self.showLoadingOnElement("whole_page", 1, "material");
      var onSuccess = (response) => {
        self.origFaqs = response.data;
        if (self.currentFilterList.length > 0) {
          self.faqs = self.origFaqs.filter(
            (x) =>
              self.currentFilterList.filter((y) => y.moduleId == x.moduleId)
                .length > 0
          );
        } else {
          self.faqs = self.origFaqs;
        }
      };
      var onFinally = (response) => {
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };

      self.$ajaxGet(self, "Faq/ListFaqs", onSuccess, onFinally);
    },
    getLogbooks(companyId) {
      var self = this;
      self.showLoading = true;

      var onSuccess = (response) => {
        self.logbooks = response.data;
      };
      var onFinally = (response) => {
        self.showLoading = false;
      };
      self.$ajaxGet(self, "MentorModule/GetLogbooksForAllStudents?companyId=" + companyId, onSuccess, onFinally);
    },
    showLoadingOnSubmitButtons(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: element.$el,
        scale: scale,
        color: "#ffffff",
      });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
  },
  mounted() {
    this.$store.dispatch("updateTheme", "dark");
    this.getMentorModules();
    this.getUnassignedSessions();
  },
};
</script>

<style lang="scss">
.theme-dark {
  .style-chooser-light {
    .vs__actions {
      mix-blend-mode: inherit !important;
    }

    .selected-tag {
      background: #b7b7b7 ;
    }

    .dropdown-menu {
      color: #3d3d3d !important;
    }
  }

  #filter-select input {
    color: #3d3d3d !important;
  }
}

#submit-button {
  &.vs-button {
    .vs-button--icon {
      font-size: 1.3rem !important;
    }
  }
}

#comment_text {
  background: #10163a;
}

.swiper-inner {
  overflow: hidden;
  // padding: 15px;
  widows: 100% !important;
}

.swiper-container {
  width: 100% !important;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
}
</style>
